/* 룩북 연도 필터 — 카페24 `#year-select` 이식.
 * 고른 연도의 카드만 남기고 개수 표시를 갱신한다.
 * ⚠️ 카드를 지우지 않고 `hidden` 클래스만 토글한다 — 되돌릴 때 다시 그릴 필요가 없다.
 * ⚠️ 섹션이 여러 개 있어도 서로 간섭하지 않도록 **그 셀렉트가 속한 섹션 안에서만** 찾는다.
 */
(() => {
  const bind = (select) => {
    const root = select.closest('.nlb');
    if (!root) return;
    const grid = root.querySelector('[data-nlb-grid]');
    const count = root.querySelector('[data-nlb-count]');
    if (!grid) return;

    select.addEventListener('change', () => {
      const want = select.value;
      let shown = 0;
      grid.querySelectorAll('[data-nlb-item-year]').forEach((card) => {
        const match = want === 'all' || card.dataset.nlbItemYear === want;
        card.classList.toggle('nlb-item--hidden', !match);
        if (match) shown += 1;
      });
      if (count) count.textContent = shown;
    });
  };

  const init = () => document.querySelectorAll('[data-nlb-year]').forEach(bind);
  init();
  /* 테마 에디터에서 섹션을 다시 그리면 리스너가 사라진다. */
  document.addEventListener('shopify:section:load', init);
})();
